import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.documentElement; // html element
    const body = document.body; // body element
    const appContainer = document.querySelector(".d-flex.flex-column.v-100"); // containerul tău principal

    // încearcă întâi pe window
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // dacă există container scrollabil, resetează și acolo
    if (appContainer) appContainer.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // fallback
    root.scrollTop = 0;
    body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
